import getOutlookMigrationDiagnosticsRequest from 'owa-service/lib/factory/getOutlookMigrationDiagnosticsRequest';
import getOutlookDotComMigrationDiagnosticsOperation from 'owa-service/lib/operation/getOutlookDotComMigrationDiagnosticsOperation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
/**
 * Helper method that creates the GetOutlookMigrationDiagnosticsRequest body
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function createRequestBody() {
    var sessionSettings = getUserConfiguration().SessionSettings;
    var emailAddresses = [
        {
            EmailAddress: sessionSettings.UserEmailAddress,
            Name: sessionSettings.UserDisplayName,
            RoutingType: 'SMTP',
        },
    ];
    return getOutlookMigrationDiagnosticsRequest({ SendReportToAddresses: emailAddresses });
}
/**
 * Get rules diagnostics report
 * @return GetOutlookMigrationDiagnosticsRequest
 */
export default function getOutlookMigrationDiagnosticsService() {
    var requestBody = createRequestBody();
    return getOutlookDotComMigrationDiagnosticsOperation(requestBody);
}
//# sourceMappingURL=getOutlookMigrationDiagnosticsService.js.map